<div style="padding: 1rem; background-color: lightgray; border-radius: 5px">
    <p-checkbox [label]="label" [(ngModel)]="selected" [binary]="true"></p-checkbox>
</div>
